import { mapApiSearchContentResultsFromApiToVm } from '~/searchApi';

import { SingleContent } from './SingleContent';
import { TalentContentProperties } from './TalentContent';

export const TalentContentReadonly = ({
  customContent: existingContent,
  showInShared,
}: TalentContentProperties) => {
  // Map the content to view model format for rendering
  const contentToRender =
    // @ts-ignore - we should figure out a way to remove the mapping :\
    mapApiSearchContentResultsFromApiToVm(existingContent);

  return (
    <>
      <div className="flex shrink-0 snap-x snap-mandatory gap-4 overflow-x-auto tab:flex-wrap">
        {contentToRender?.map((content) => {
          return (
            <SingleContent
              key={content.id}
              content={content}
              showInShared={showInShared}
            />
          );
        })}
        <div className="grow-[999]">
          {/* This div is necessary to prevent last image to expand full width */}
        </div>
      </div>
    </>
  );
};
